import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

import { withRouter, Link } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import logoLight from "../../assets/images/logo-light.png";
import logo from "../../assets/images/lcbtp.png";
import { useLogin } from "../../hooks/useAuth";

//Import config

const Login = () => {
  const [passwordShow, setPasswordShow] = useState(false);
  const { mutate: loginMutate, isLoading } = useLogin();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Veuillez saisir votre email"),
      password: Yup.string().required("Veuillez saisir votre mot de password"),
    }),
    onSubmit: (values) => {
      loginMutate({ email: values.email, password: values.password });
    },
  });

  document.title = "Connexion | Le Conseiller du BTP";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <ToastContainer closeButton={false} />
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logo} width="32%" alt="" />
                    </Link>
                  </div>
                  {/* <p className="mt-1 fs-15 fw-medium" style={{color:'#FF6600'}}>Le Conseiller du BTP</p> */}
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card>
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      {/* <h5 className="text-primary" style={{color:'#FF6600'}}>Bienvenue !</h5> */}
                      <p
                        className="mt-1 fs-15 fw-medium"
                        style={{ color: "#FF6600" }}
                      >
                        {" "}
                        Le Conseiller du BTP !
                      </p>
                    </div>
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#"
                      >
                        <div className="mb-3">
                          <Label htmlFor="email" className="form-label">
                            Email
                          </Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Entrer votre adresse email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <div className="float-end">
                            <Link
                              to="/auth-pass-reset-basic"
                              className="text-muted"
                            >
                              Mot de passe oublié ?
                            </Link>
                          </div>
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Mot de passe
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              className="form-control pe-5"
                              placeholder="Entrez votre mot de passe"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              onClick={() => setPasswordShow(!passwordShow)}
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        <div className="mt-4">
                          <Button
                            className={`btn w-100 ${
                              isLoading ? "loading" : ""
                            }`}
                            style={{
                              height: "40px",
                              backgroundColor: "#FF6600",
                              border: "#FF6600",
                            }}
                            type="submit"
                          >
                            {isLoading ? (
                              <div className="loader"></div>
                            ) : (
                              "Se connecter"
                            )}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
